export var links = {
    login: "/login",
    register: "/register",
    account: "/account",
    usageBlockShowcase: "/account/usage-blocks",
    forgotPassword: "/forgot-password",
    endpointsForms: "/endpoints-forms",
    stats: "/stats",
    fileImports: "/imports",
    paymentMethod: "/payment-method",
    privacy: "/privacy",
    supplementalPrivacy: "/notice-at-collection",
    optOut: "/do-not-sell",
    home: "/",
};
